import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowFitTopLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.748 3A2.75 2.75 0 0 0 3 5.75v9.953a.75.75 0 0 0 1.5 0V5.75q0-.09.012-.177L18.442 19.5h-6.158a.75.75 0 0 0 0 1.5h8.717v-8.716h-.75.75a.75.75 0 1 0-1.5 0h.75-.75v6.154L5.573 4.513q.086-.012.175-.012h9.955a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopLeft24);
